import MenuUtil from '../../../../utils/menu';
export function shouldDisplayItemImages(items) {
  return MenuUtil.hasImageInSomeItems(items);
}